import { Input } from '../ui/input';
import RichTextEditor from '../RichTextEditor';

const AboutEditor = ({ data, setData }) => {
  const d = data;
  return (
    <div className="space-y-4">
      <div>
        <label className="block text-sm font-medium mb-1">عنوان القسم</label>
        <Input value={d.title || ''} onChange={e => setData({ ...d, title: e.target.value })} placeholder="عن المبادرة" data-testid="about-title" />
      </div>
      <div>
        <label className="block text-sm font-medium mb-1">المحتوى</label>
        <RichTextEditor value={d.content || ''} onChange={val => setData({ ...d, content: val })} />
      </div>
    </div>
  );
};

export default AboutEditor;
